// Pair once; subsequent requests only observe provider state. Secrets stay in memory.
export function normalizePairingPhone(value) {
  if (typeof value !== 'string' || !/^\+?[0-9 ()-]+$/.test(value)) return '';
  const phone = value.replace(/[+ ()-]/g, '');
  return /^[1-9][0-9]{6,14}$/.test(phone) ? phone : '';
}

export function createPairingLogin({ api, id, phone, valid, code, message, error,
  connected, done, now = () => Date.now(),
  schedule = (fn, ms) => setTimeout(fn, ms), cancel = clearTimeout }) {
  let stopped = false, started = false, timer, expiry, requested = false, recoveries = 0;
  let opened, expiresAt;
  const alive = () => !stopped && valid();
  const stop = () => { stopped = true; phone = ''; cancel(timer); cancel(expiry); };
  const finish = (text, success = false) => {
    code(''); message(text); stop(); done();
    if (success) connected();
  };
  async function update() {
    if (!alive()) return;
    if (expiresAt && now() >= expiresAt) {
      finish('配对码展示已超时，请重新获取或改用扫码。'); return;
    }
    if (!requested && now() - opened >= 60000) {
      finish('连接准备超时，请稍后重试或改用扫码。'); return;
    }
    try {
      if (!requested) {
        const state = await api.prepareQr(id, recoveries < 2);
        if (!alive()) return;
        if (now() - opened >= 60000) { finish('连接准备超时，请稍后重试或改用扫码。'); return; }
        if (state.recovery_started) recoveries += 1;
        if (state.state === 'connected') { finish('账号已连接，无需配对。', true); return; }
        if (state.state === 'failed') { finish('连接暂不可用，请稍后重试或改用扫码。'); return; }
        if (state.state === 'ready') {
          requested = true;
          const pending = api.requestPairingCode(id, phone);
          phone = '';
          const result = await pending;
          if (!alive()) return;
          if (result.state === 'connected') { finish('账号已连接，无需配对。', true); return; }
          if (!/^[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(result.code || '')) throw new Error('Invalid pairing response');
          expiresAt = now() + 120000;
          code(result.code);
          message('请在手机 WhatsApp 中输入此配对码。此窗口最多展示 2 分钟。');
          expiry = schedule(() => {
            if (alive()) finish('配对码展示已超时，请重新获取或改用扫码。');
          }, 120000);
        }
      } else {
        const state = await api.pairingStatus(id);
        if (!alive()) return;
        if (state.state === 'connected') { finish('WhatsApp 已连接。', true); return; }
        if (state.state !== 'waiting') { finish('连接状态已变化，请重新获取配对码或改用扫码。'); return; }
      }
    } catch (e) {
      if (!alive()) return;
      error(e);
      if (!alive()) return;
      finish(e.response?.status === 429
        ? '申请过于频繁，请等待 2 分钟后重试或改用扫码。'
        : '配对暂未完成，请等待 2 分钟后重试或改用扫码。');
      return;
    }
    if (alive()) timer = schedule(update, 5000);
  }
  return { start: () => {
    if (started || !alive()) return;
    started = true; opened = now();
    const normalized = normalizePairingPhone(phone);
    if (!normalized) { finish('请输入含国家区号的有效手机号。'); return; }
    phone = normalized;
    message('正在准备手机配对连接…');
    return update();
  }, stop };
}
